import React, { useRef } from 'react';
import { Router, browserHistory, Route } from 'react-router';
import { useDispatch } from 'react-redux';
import { cacheManager } from 'utils/cache-manager';
import { logError } from 'actions/error';
import googleTagsManager from 'utils/google-tags-manager';

import { NotFound } from './pages/not-found-404';
import AuthHandler from './pages/AuthHandler';

const getPageLocation = (origin, pathname) => `${origin}${pathname}`;

export default function Root({ routes = () => {} }) {
    const dispatch = useDispatch();
    const prevFullUrlRef = useRef('');

    const onRouteUpdate = () => {
        cacheManager.removeExpired();
        const { current: prevFullUrl = '' } = prevFullUrlRef;
        const { href, origin, pathname } = window.location;

        try {
            if (prevFullUrl) {
                const { origin: referrerOrigin, pathname: referrerPathname } = new URL(prevFullUrl);
                const pageLocation = getPageLocation(origin, pathname);

                if (pageLocation !== getPageLocation(referrerOrigin, referrerPathname)) {
                    googleTagsManager.push({
                        event: 'pageView',
                        pageLocation,
                        pageReferrer: prevFullUrl,
                        pageTitle: document.title,
                    });
                }
            }

            rstat('event', 'screen_change', { type: 'History' });
        } catch (e) {
            dispatch(logError({ message: e?.message, stack: e?.stack }));
        } finally {
            prevFullUrlRef.current = href;
        }
    };

    return (
        <Router history={browserHistory} onUpdate={onRouteUpdate}>
            {routes()}
            <Route path="auth/handler" component={AuthHandler} />
            <Route path="*" component={NotFound} status={404} />
        </Router>
    );
}
